import { Modal } from 'antd';
import type { CargoProps } from '@api/models/cargo';

type LaytimeValueFields = Pick<
	CargoProps,
	'demurrage' | 'despatch' | 'demurrageLoading' | 'despatchLoading' | 'demurrageDischarge' | 'despatchDischarge' |
	'timeAllowed' | 'timeAllowedLoading' | 'timeAllowedDischarging'
>;

const hasLaytimeValues = (cargo: Partial<LaytimeValueFields>) => [
	cargo.demurrage,
	cargo.despatch,
	cargo.demurrageLoading,
	cargo.despatchLoading,
	cargo.demurrageDischarge,
	cargo.despatchDischarge,
	cargo.timeAllowed,
	cargo.timeAllowedLoading,
	cargo.timeAllowedDischarging,
].some((value) => value != null && Number(value) !== 0);

export const confirmLaytimeTermsChange = (
	cargo: Partial<LaytimeValueFields>,
	onConfirm: () => void,
) => {
	if (!hasLaytimeValues(cargo)) {
		onConfirm();

		return;
	}

	Modal.confirm({
		title: 'Change laytime type?',
		content: 'Changing the laytime type clears the time allowed, demurrage and despatch on this cargo.',
		okText: 'Change',
		cancelText: 'Cancel',
		onOk: onConfirm,
	});
};
